// @flow
export type ThemePropValue =
  | string
  | number
  | { [key: string]: ThemePropValue, ... };

export type UtilThemeProps = {
  theme: Theme,
  ...
};

export type Theme = {
  settings: { [settingName: string]: string },
  [key: string]: ThemePropValue,
  ...
};
